export interface FileDescriptionsWithTotal {
  data: FileDescription[];
  total: number;
  employeeDocumentCount?: number;
}

export interface FileDescription {
  readonly id?: number;
  name: string;
  readonly size?: number;
  mediaType?: string;
  tags?: FileTags;
  status?: StatusEnum;
  type: string;
  family?: string;
  subFamily?: string;
  storageType: StorageTypeEnum;
  employeeId?: number;
  contractId?: number;
  entityId?: number;
  payPeriodId?: number;
  originPayPeriodId?: number;
  payExecId?: number;
  paySerieId?: number;
  payType?: string;
  businessName?: string;
  readonly etag?: string;
  readonly cliCoreId?: number;
  readonly md5?: string;
  url?: string;
  exportableToNifi?: boolean;
  creationDate?: string;
  updateDate?: string;
  storedCompressed?: boolean;
  userId?: number;
  signatureStatus?: SignatureStatusEnum;
  signatureData?: SignatureData;
}

export interface FileTags {
  payTypeTransId?: string;
  grossSalary?: string;
  employeeTaxesAndCosts?: string;
  companyTaxesAndCosts?: string;
  netPay?: string;
  payPeriodTransId?: string;
  originPayExecId?: number;
  isRetroDisplay?: boolean;
  type?: string;
  retroPayslipCount?: number;
  originPayPeriodTransId?: string;
  originPayPeriodId?: string;
  creator?: string;
  firstName?: string;
  lastName?: string;
  lastModifier?: string;
  id?: number;
}

export enum StatusEnum {
  DRAFT = 'DRAFT',
  DISCARDED = 'DISCARDED',
  VALIDATED = 'VALIDATED',
  INTRANSIT = 'IN_TRANSIT',
  SENT = 'SENT',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  DELETED = 'DELETED',
  DONE = 'DONE',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  INITIATED = 'INITIATED'
}

export enum StorageTypeEnum {
  INTERNAL = 'INTERNAL'
}

export enum SignatureStatusEnum {
  NOT_DEFINED = 'NOT_DEFINED',
  AVAILABLE = 'AVAILABLE',
  PROCESSING = 'PROCESSING',
  PROVIDERERROR = 'PROVIDERERROR',
  SIGNATUREPENDING = 'SIGNATUREPENDING',
  CLIENTCALLBACK_PENDING = 'CLIENTCALLBACKPENDING',
  CLIENTCALLBACKERROR = 'CLIENTCALLBACKERROR',
  FINISHED = 'FINISHED',
  DELETED = 'DELETED',
  REVOKED = 'REVOKED'
}

export enum SignatureMethodEnum {
  MANUAL = 'MANUAL',
  BEID = 'BEID',
  ITSME = 'ITSME',
  SMSOTP = 'SMSOTP',
  MAILOTP = 'MAILOTP',
  ITSMEE2E = 'ITSMEE2E'
}

export interface SignatureDataEntry {
  role: string;
  imageFingerprint: string;
  signatureMethods: SignatureMethodEnum[];
  signingOrder: number;
  signatureImage?: string;
}

export interface SignatureData {
  id?: string;
  status?: SignatureStatusEnum;
  signatureInfos?: SignatureInfo[];
}

export interface SignatureInfo {
  signingFieldPlacement?: SigningFieldPlacement;
  markerName?: string;
  signer?: SignerInfo;
  signatureMethods?: SignatureMethodEnum[];
}

export interface SigningFieldPlacement {
  page?: number;
  top?: number;
  left?: number;
  width?: number;
  height?: number;
}

export interface SignerInfo {
  language?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  birthDate?: string;
  phoneNumber?: string;
  redirectUrl?: string;
  signingOrder?: number;
}

export interface SignatureLocation {
  id: string;
  page: number;
  left: number;
  top: number;
  width: number;
  height: number;
  signatureMethods?: SignatureMethodEnum[];
  signingOrder?: number;
}

export interface FileStats {
  maxAllowed: number;
  actualCount: number;
  canCreateFile: boolean;
}
